export const loginTranslations = {
    en: {
        "authorization": "Authorization",
        "member": "Member id",
        "sgsMember": "SGS Member id",
        "email": "Email",
        "memberIdOrEmail": "Input your member id or email",
        "magicLinkTo": "Login link sent to:",
        "inputPassword": "Input password",
        "forgotPassword": "Forgot password?",
        "password": "Password",
        "preferLogin": "How you prefer to login?",
        "withPassword": "With password",
        "withMagicLink": "Send me email with login link",
        "previous": "Previous",
        "next": "Next",
        "submit": "Submit"
    },
    fi: {
        "authorization": "Kirjautuminen",
        "member": "SGS-nro",
        "sgsMember": "SGS Jäsennumero",
        "email": "Sähköposti",
        "memberIdOrEmail": "Syötä jäsennumerosi tai sähköpostiosoitteesi",
        "magicLinkTo": "Kirjautumislinkki lähetetty:",
        "inputPassword": "Syötä salasana",
        "forgotPassword": "Unohditko salasanasi?",
        "password": "Salasana",
        "preferLogin": "Miten haluat kirjautua?",
        "withPassword": "Salasanalla",
        "withMagicLink": "Lähetä kirjautumislinkki sähköpostiini",
        "previous": "Edellinen",
        "next": "Seuraava",
        "submit": "Lähetä"
    }
}
